import type { MouseEvent } from 'react';

/*
 * A click that means "go there, here". A middle click or a held modifier means
 * "somewhere else" and stays the browser's, which is why the link stays real.
 */
export function isPlainClick(event: MouseEvent<Element>): boolean {
  return (
    event.button === 0 &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.shiftKey &&
    !event.altKey
  );
}
